import { Grid } from "@mui/material";
import { PropertyCard } from "../../../components/property/PropertyCard";
import { makeUrl } from "../../../../fe-ui/utils/makeUrl";
import { ExtendedHotelUnitGroupDto, ExtendedOfferDto } from "../../../../api/aggregation-client/service";

type Props = {
  offer: ExtendedOfferDto;
  basePath?: string;
  arrivalDate: string;
  departureDate: string;
  totalAdults: number;
  totalChildren: number;
  showTotalPrice: boolean;
  disableOpenInNewTab?: boolean;
  compactWidth?: boolean;
};

export const PropertyCardComponent = ({
  offer,
  basePath,
  arrivalDate,
  departureDate,
  totalAdults,
  totalChildren,
  showTotalPrice,
  disableOpenInNewTab,
  compactWidth,
}: Props) => {
  const [cheapestRatePlan] = offer.ratePlans.sort((a, b) => {
    return a.pricePerNightDetails.priceWithTax - b.pricePerNightDetails.priceWithTax;
  });

  const imageUrlList = (offer.unitGroup as ExtendedHotelUnitGroupDto).media.reduce<string[]>(
    (acc, media, idx, origArr) => {
      if (acc.length > 9) {
        origArr.splice(idx);
        return acc;
      }
      return media?.media_type === "photo" ? [...acc, media?.url] : acc;
    },
    []
  );

  return (
    <Grid item xs={12} sm={6} md={compactWidth ? 6 : 4} lg={compactWidth ? 4 : 3}>
      <PropertyCard
        area={(offer.unitGroup as ExtendedHotelUnitGroupDto).area}
        unitAttributes={(offer.unitGroup as ExtendedHotelUnitGroupDto).attributes}
        hotelAttributes={offer.hotel?.attributes}
        unitGroupType={(offer.unitGroup as ExtendedHotelUnitGroupDto).unitGroupType}
        showTotalPrice={showTotalPrice}
        link={makeUrl(`${basePath || ""}/unit/${offer.unitGroupId}`, {
          arrivalDate: offer?.arrivalDate || arrivalDate,
          departureDate: offer?.departureDate || departureDate,
          adults: totalAdults,
          children: totalChildren,
          hotelId: offer.hotelId,
          unitGroupId: offer.unitGroupId,
          ratePlanId: cheapestRatePlan.ratePlanId,
        })}
        promotionLabels={(offer.unitGroup as ExtendedHotelUnitGroupDto).promotionLabels}
        title={(offer.unitGroup as ExtendedHotelUnitGroupDto).title}
        description={
          (offer.unitGroup as ExtendedHotelUnitGroupDto).shortDescription ||
          (offer.unitGroup as ExtendedHotelUnitGroupDto).description
        }
        pricePerNightDetails={cheapestRatePlan.pricePerNightDetails}
        image={(offer.unitGroup as ExtendedHotelUnitGroupDto).media[0]?.url}
        imageList={imageUrlList}
        arrivalDate={offer?.arrivalDate}
        departureDate={offer?.departureDate}
        id={offer.unitGroupId}
        subtitle={offer.hotel?.title}
        hotelId={offer.hotelId}
        priceDetails={cheapestRatePlan.priceDetails}
        openInNewTab={!disableOpenInNewTab}
      />
    </Grid>
  );
};
